module.exports = __webpack_public_path__ + "media/images/japan/useful_4-c8d47a77dd933e7de45d6e8bd3d1378b.jpg";